// @flow strict
import React, { useState } from "react";
import { withPrefix, Link } from "gatsby";
import styles from "./Author.module.scss";

type Props = {
  author: {
    name: string,
    bio: string,
    photo: string
  },
  isIndex: ?boolean
};

const Author = ({ author, isIndex }: Props) => {
  const [theme, setTheme] = useState(
    typeof document !== "undefined"
      ? document.getElementsByClassName("black").length > 0
      : false
  );

  const addTheme = () => {
    const element = document.getElementById("___gatsby");

    const hasBlack = document.getElementsByClassName("black");

    console.log(theme, document.getElementsByClassName("black"));

    if (hasBlack.length > 0) {
      setTheme(false);
      return element.classList.remove("black");
    }

    setTheme(true);
    return element.classList.add("black");
  };

  return (
    <div className={styles["author"]}>
      <Link to="/">
        <img
          src={withPrefix(author.photo)}
          className={styles["author__photo"]}
          width="75"
          height="75"
          alt={author.name}
        />
      </Link>
      {isIndex === true ? (
        <h1 className={styles["author__title"]}>
          <Link className={styles["author__title-link"]} to="/">
            {author.name}
          </Link>
        </h1>
      ) : (
        <h2 className={styles["author__title"]}>
          <Link className={styles["author__title-link"]} to="/">
            {author.name}
          </Link>
        </h2>
      )}

      <div class="theme-switch-wrapper">
        <label class="theme-switch" for="checkbox">
          <input type="checkbox" id="checkbox" checked={!!theme} />
          <div class="slider round" onClick={() => addTheme()}></div>
        </label>
        <p className={styles["author__subtitle"]} onClick={() => addTheme()}>
          {!theme ? "Light" : "Dark"} Mode
        </p>
      </div>

      <p className={styles["author__subtitle"]}>{author.bio}</p>
    </div>
  );
};

export default Author;
